import { selectAll } from "@fruugo/utilities";
import { polyfillDetailsHashOpen } from "../polyfills/open-details-with-hash-polyfill";

const ACTIVE_CLASSES = [
  "tw:border-fruugo-blue-secondary",
  "tw:font-bold",
  "tw:text-fruugo-blue-secondary",
];
const DEFAULT_CLASS = "tw:border-fruugo-border-control";

function syncButton(btn: HTMLElement, details: HTMLDetailsElement) {
  ACTIVE_CLASSES.forEach((cls) => btn.classList.toggle(cls, details.open));
  btn.classList.toggle(DEFAULT_CLASS, !details.open);
}

export const initProductTabs = () => {
  polyfillDetailsHashOpen();

  const pairs: { btn: HTMLElement; details: HTMLDetailsElement }[] = [];

  const buttons = selectAll<HTMLElement>(".js-product-tab");
  if (!buttons || buttons.length < 1) return;

  buttons.forEach((btn) => {
    const targetName = btn.dataset?.tabTarget;
    if (!targetName) return;

    const target = document.getElementById(targetName);
    const details = target?.closest<HTMLDetailsElement>("details");
    if (!details) return;

    pairs.push({ btn, details });

    details.addEventListener("toggle", () => syncButton(btn, details));
    btn.addEventListener("click", () => (details.open = true));

    // Cover the case where this panel is already open at init time
    // (server-rendered default, or opened by native fragment navigation).
    syncButton(btn, details);
  });

  handleDefaultPanelOnDesktop(pairs);
};

const handleDefaultPanelOnDesktop = (
  pairs: { btn: HTMLElement; details: HTMLDetailsElement }[]
) => {
  const groupName = "product-tabs";
  const desktopQuery = window.matchMedia("(min-width: 1024px)");
  const panels = pairs.map((p) => p.details);

  function applyMode() {
    if (desktopQuery.matches) {
      const openPanels = panels.filter((p) => p.open);

      const hashTarget = location.hash
        ? document.getElementById(location.hash.slice(1))
        : undefined;
      const hashPanel = hashTarget?.closest<HTMLDetailsElement>("details");

      const keepOpen =
        (hashPanel && openPanels.includes(hashPanel) && hashPanel) ||
        openPanels[0] ||
        panels[0];

      panels.forEach((panel) => {
        panel.open = panel === keepOpen;
      });
      panels.forEach((panel) => panel.setAttribute("name", groupName));
    } else {
      panels.forEach((panel) => panel.removeAttribute("name"));
    }

    // Don't rely on 'toggle' having fired — resync every button explicitly,
    // since setting .open to its current value is a silent no-op.
    pairs.forEach(({ btn, details }) => syncButton(btn, details));
  }

  desktopQuery.addEventListener("change", applyMode);
  applyMode();
};
